<template>
    <nav>
        <div class="container">
            <div class="nav">
                <a class="logo">
                    <div class="logo-img">
                        <router-link :to="logoLink">
                            <img src="@/assets/img/prime_logo.png" alt="BIB Institute" />
                        </router-link>
                    </div>
                    <div class="logo-text">
                        <router-link :to="logoLink">
                            <p>Prime International School</p>
                        </router-link>
                    </div>
                </a>
                <div class="top-nav align-center" :class="{ open: isMenuOpen }">
                    <div class="dropdown" @click="toggleDropdown">
                        <a class="dropdown-menu">
                            <i class="fa-solid fa-user"></i>
                            {{ this.$store.state.user.name | adminDisplayName }}
                            <span><i class="fa-solid fa-caret-down"></i></span>
                        </a>
                        <ul class="dropdown-item dropdown_menu--animated dropdown_animation"
                            :class="{ show: isDropdownOpen}">
                            <li v-if="id != '0001' && role !== CONFIG.ROLE.ID.HR_OPERATOR">
                                <router-link :to="{
                                    name: 'employeeProfile',
                                    params: { id: this.$store.state.user.employee.id },
                                }">
                                    <a>My Profile</a>
                                </router-link>
                            </li>
                            <li v-if="id != '0001'">
                                <router-link :to="{
                                    name: 'school',
                                    params: { id: this.$store.state.user.campus_id },
                                }">
                                    <a>Campus Info</a>
                                </router-link>
                            </li>
                            <li v-if="id == '0001'">
                                <router-link :to="{ name: 'campusList' }">
                                    <a>Campus</a>
                                </router-link>
                            </li>
                            <li v-if="id == '0001'">
                                <router-link :to="{ name: 'employeeList' }">
                                    <a>Employee</a>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'updatePassword' }">
                                    <a>Update Password</a>
                                </router-link>
                            </li>
                            <li v-if="id != '0001' && role !== CONFIG.ROLE.ID.HR_OPERATOR && role !== CONFIG.ROLE.ID.SUPER_ADMIN">
                                <router-link :to="{ name: 'myPayslipList' }">
                                    <a>My Payslip Records</a>
                                </router-link>
                            </li>
                            <li v-if="id != '0001' && (role == CONFIG.ROLE.ID.ADMIN || role == CONFIG.ROLE.ID.PRINCIPAL || role == CONFIG.ROLE.ID.HR_OPERATOR || role == CONFIG.ROLE.ID.SUPER_ADMIN)">
                                <router-link :to="{ name: 'customSettingPage' }">
                                    <a>Setting</a>
                                </router-link>
                            </li>
                            <li class="border">
                                <a @click="logoutUser" class="btn-cursor"><i class="fa-solid fa-right-from-bracket"></i>
                                    Logout</a>
                            </li>
                        </ul>
                    </div>
                    <div class="hamburger" @click="toggleMenu" :class="{ open: isMenuOpen }" v-if="id != '0001'">
                        <div class="hamburger-line" v-for="index in 3" :key="index"></div>
                    </div>
                </div>
            </div>
            <div class="nav-menu" :class="{ open: isMenuOpen }" v-if="id != '0001'">
                <ul class="nav-menu-list">
                    <li class="dropdown" :class="{ active: isDashboardActive }"
                        v-if="![CONFIG.ROLE.ID.LIBRARY_ADMIN, CONFIG.ROLE.ID.CLASS_MONITOR].includes(role)">
                        <router-link :to="{ name: 'dashboard' }"><a class="dd-hover"><i
                                    class="fa-solid fa-house"></i>Dashboard</a></router-link>
                    </li>

                    <li class="dropdown" :class="{ active: isConfigurationActive }"
                        v-if="showConfiguration && ![CONFIG.ROLE.ID.LIBRARY_ADMIN, CONFIG.ROLE.ID.CLASS_MONITOR].includes(role)">
                        <a class="dropdown-menu" @click="toggleDropdown('configuration')"><i
                                class="fa-solid fa-gears"></i>Configuration</a>
                        <div class="dropdown-item mega-menu dropdown_menu--animated dropdown_animation"
                            :class="{ show: isDropdownOpen('configuration') }">
                            <div class="mega-col" v-if="canShowAcademicSetup">
                                <div class="mega-title">Academic Setup</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'periodList' }"><a>Academic Period
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'gradeList' }"><a>Grade List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'holidayList' }"><a>Holiday List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'appFormList' }"><a>Application Form</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'timetableTemplateList' }"><a>Timetable Template
                                                List</a></router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="mega-col" v-if="canShowOperationalSetup">
                                <div class="mega-title">Operational Setup</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'shiftSetting' }"><a>Shift Setting</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'shiftPatternList' }"><a>Shift Pattern
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'teacherTypeList' }"><a>Teacher Type
                                                List</a></router-link>
                                    </li>
                                    <li v-if="[CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'leaveTypeList' }"><a>Leave Type
                                                List</a></router-link>
                                    </li>
                                    <li v-if="[CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'leaveBalanceList' }"><a>Leave Balance
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'positionList' }"><a>Position List</a></router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="mega-col" v-if="canShowFinancialSetup">
                                <div class="mega-title">Financial Setup</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'paymentMethodList' }"><a>Payment Method
                                                List</a></router-link>
                                    </li>
                                    <li v-if="[CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'paymentAttributeList' }"><a>Payment Attribute
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'gradeFeeList' }"><a>Grade Fee List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'itemList' }"><a>Payment Item List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'transactionCategoryList' }"><a>Transaction Category
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'discountTypeList' }"><a>Discount Type
                                                List</a></router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    <li class="dropdown" :class="{ active: isAcademicUsersActive }"
                        v-if="showAcademicAndUser && ![CONFIG.ROLE.ID.LIBRARY_ADMIN, CONFIG.ROLE.ID.CLASS_MONITOR, CONFIG.ROLE.ID.HR_OPERATOR].includes(role)">
                        <a class="dropdown-menu" @click="toggleDropdown('academicUsers')"><i
                                class="fa-solid fa-users"></i>Academic &amp; Users</a>
                        <div class="dropdown-item mega-menu dropdown_menu--animated dropdown_animation"
                            :class="{ show: isDropdownOpen('academicUsers') }">
                            <div class="mega-col" v-if="canShowGradesAndClasses">
                                <div class="mega-title">Grades &amp; Classes</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'campusGradeList' }"><a>Campus Grade
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'classList' }"><a>Class List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'subjectList' }"><a>Subject List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'timetableList' }"><a>TimeTable List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'scoreSettingList' }"><a>Score Setting
                                                List</a></router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="mega-col" v-if="canShowStudents">
                                <div class="mega-title">Students</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'studentList' }"><a>Student List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'parentList' }"><a>Parent List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'applicantList' }"><a>Applicants</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'referralManagementList' }"><a>Referral
                                                Management</a></router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    <li class="dropdown" :class="{
                        active: isOperationsActive,
                        'lib-admin': role == CONFIG.ROLE.ID.CLASS_MONITOR,
                        'role-dropdown-fix': role == CONFIG.ROLE.ID.CLASS_MONITOR
                    }" v-if="showOperation && role !== CONFIG.ROLE.ID.LIBRARY_ADMIN">
                        <a class="dropdown-menu" @click="toggleDropdown('operations')"><i
                                class="fa-solid fa-diagram-project"></i>Operations</a>
                        <div class="dropdown-item mega-menu dropdown_menu--animated dropdown_animation"
                            :class="{ show: isDropdownOpen('operations'), 'mega-align-nav': role != CONFIG.ROLE.ID.HR_OPERATOR }">
                            <div class="mega-col" v-if="canShowStudentTracking">
                                <div class="mega-title">Student Tracking</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.CLASS_MONITOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'attendanceStudentList' }"><a>Daily Attendance
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.CLASS_MONITOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'monthlyAttendance' }"><a>Monthly Attendance
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.CLASS_MONITOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'attendanceRateList' }"><a>Attendance Rate
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.CLASS_MONITOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'leaveList' }"><a>Leave List</a></router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="mega-col" v-if="canShowEmployeeTracking">
                                <div class="mega-title">Employee Tracking</div>
                                <ul class="mega-list">
                                    <li v-if="role == CONFIG.ROLE.ID.HR_OPERATOR || role == CONFIG.ROLE.ID.SUPER_ADMIN">
                                        <router-link :to="{ name: 'employeeList' }"><a>All Employee List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'attendanceTeacherList' }"><a>Attendance
                                                List</a></router-link>
                                    </li>
                                    <li v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'teacherMonthlyAttendance' }"><a>Monthly Attendance
                                                History</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'teacherLeaveList' }"><a>Leave List</a></router-link>
                                    </li>
                                    <li v-if="[CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'ShiftAssign' }"><a>Shift Assign</a></router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="mega-col" v-if="canShowAcademicActions">
                                <div class="mega-title">Academic Actions</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'subjectTeacherList' }"><a>Subject Assign
                                                Lists</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'courseList' }"><a>Course List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'assignmentList' }"><a>Assignment
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'examList' }"><a>Exam List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'gradingList' }"><a>Grading List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'earlyYearList' }"><a>Early Year Grading
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'ClassScoreSummary' }"><a>Score
                                                Summary</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.CLASS_MONITOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'reportCardGradingList' }"><a>Report Card Grading
                                                List</a></router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="mega-col" v-if="canShowCommunication">
                                <div class="mega-title">Communication</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'noticeList' }"><a>Notice List</a></router-link>
                                    </li>
                                    <li
                                        v-if="$store.state.setting.teacherChatApproval && [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'chatRequestList' }"><a>Chat Request
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'ChatMessageHistory' }"><a>Chat Message
                                                History</a></router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    <li class="dropdown" :class="{ active: isFinancesActive }"
                        v-if="showFinance && ![CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.LIBRARY_ADMIN, CONFIG.ROLE.ID.CLASS_MONITOR].includes(role)">
                        <a class="dropdown-menu" @click="toggleDropdown('finances')"><i
                                class="fa-solid fa-coins"></i>Finances</a>
                        <div class="dropdown-item mega-menu mega-align-right dropdown_menu--animated dropdown_animation"
                            :class="{ show: isDropdownOpen('finances') }">
                            <div class="mega-col" v-if="canShowStudentBillings">
                                <div class="mega-title">Student Billings</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'paymentList' }"><a>Invoice List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'studentStatementList' }"><a>Student Statement
                                                List</a></router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="mega-col" v-if="canShowPayroll">
                                <div class="mega-title">Payroll</div>
                                <ul class="mega-list">
                                    <li v-if="[CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'SalaryChangesHistoryList' }"><a>Salary Changes
                                                History</a></router-link>
                                    </li>
                                    <li v-if="[CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'skillList' }"><a>Skill List</a></router-link>
                                    </li>
                                    <li v-if="[CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'paymentAttributeDetailList' }"><a>Payment Attribute
                                                Detail</a></router-link>
                                    </li>
                                    <li v-if="[CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'payslipList' }"><a>Payslip History</a></router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="mega-col" v-if="canShowLedgerAndAssets">
                                <div class="mega-title">Ledger &amp; Assets</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'transactionList' }"><a>Transaction
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'paymentMethodBalanceList' }"><a>Payment Method
                                                Balances</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'refundHistoryList' }"><a>Refund
                                                History</a></router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>

                    <li class="dropdown" :class="{
                        active: isCampusServicesActive,
                        'lib-admin': role == CONFIG.ROLE.ID.LIBRARY_ADMIN,
                        'role-dropdown-fix': role == CONFIG.ROLE.ID.LIBRARY_ADMIN
                    }" v-if="showCampusService && role !== CONFIG.ROLE.ID.CLASS_MONITOR">
                        <a class="dropdown-menu" @click="toggleDropdown('campusServices')"><i
                                class="fa-solid fa-building"></i>Campus Services</a>
                        <div class="dropdown-item mega-menu mega-align-right dropdown_menu--animated dropdown_animation"
                            :class="{ show: isDropdownOpen('campusServices') }">
                            <div class="mega-col" v-if="canShowFerry">
                                <div class="mega-title">Ferry / Transport</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'driverList' }"><a>Driver List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'ferryList' }"><a>Ferry List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'routeList' }"><a>Route List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'ferryPickupList' }"><a>Ferry Pickup
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'dailyFerryList' }"><a>Daily Ferry
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'ferryZoneList' }"><a>Ferry Zone
                                                List</a></router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="mega-col" v-if="canShowLibrary">
                                <div class="mega-title">Library</div>
                                <ul class="mega-list">
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.LIBRARY_ADMIN, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'categoryItems' }"><a>Category List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.LIBRARY_ADMIN, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'bookList' }"><a>Book List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.LIBRARY_ADMIN, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'libraryMemberList' }"><a>Library Member
                                                List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.LIBRARY_ADMIN, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'checkoutList' }"><a>Checkout List</a></router-link>
                                    </li>
                                    <li
                                        v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.LIBRARY_ADMIN, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                        <router-link :to="{ name: 'damageLossesList' }"><a>Damage and Losses
                                                List</a></router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>

                    <li class="dropdown" :class="{ active: isReportMenuActive }"
                        v-if="showReport && ![CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.LIBRARY_ADMIN, CONFIG.ROLE.ID.CLASS_MONITOR].includes(role)">
                        <a class="dropdown-menu" @click="toggleDropdown('reports')"><i
                                class="fa-solid fa-chart-simple"></i>Reports</a>
                        <div class="dropdown-item dropdown-item-end dropdown_menu--animated dropdown_animation"
                            :class="{ show: isDropdownOpen('reports') }">
                            <ul>
                                <li
                                    v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                    <router-link :to="{ name: 'transactionReport' }">Profit/Loss</router-link>
                                </li>
                                <li
                                    v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                    <router-link
                                        :to="{ name: 'incomeExpenseReport' }"><a>Income/Expense</a></router-link>
                                </li>
                                <li v-if="![CONFIG.ROLE.ID.ACCOUNTANT].includes(role)">
                                    <router-link :to="{ name: 'PassPercentage' }"><a>Pass Percentage</a></router-link>
                                </li>
                                <li
                                    v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                    <router-link :to="{ name: 'TuitionFeePaymentReport' }"><a>Tuition Fee Payment
                                            Report</a></router-link>
                                </li>
                                <li
                                    v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                    <router-link :to="{ name: 'dailyCashflow' }"><a>Daily Cashflow</a></router-link>
                                </li>
                                <li
                                    v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                    <router-link :to="{ name: 'monthlyCashflow' }"><a>Monthly Cashflow</a></router-link>
                                </li>
                                <li
                                    v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                    <router-link :to="{ name: 'yearlyCashflow' }"><a>Yearly Cashflow</a></router-link>
                                </li>
                                <li
                                    v-if="[CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(role)">
                                    <router-link :to="{ name: 'financialSummaryReport' }">Financial Summary
                                        Report</router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import store from "@/store";
import axios from "axios";
import { routeNames } from '@/assets/js/routeMenus.custom';
import CONFIG from "@/assets/js/config.custom.js";
export default {
    name: "HeaderPage",
    data() {
        return {
            role: store.state.user.role,
            id: store.state.user.admin_no,
            campusCode: store.state.user.campus_master.campus_code,
            isMenuOpen: false,
            openDropdownKey: null,
            CONFIG,
        };
    },

    computed: {
        logoLink() {
            return this.id === '0001' ? { name: 'employeeList' } : { name: 'dashboard' };
        },
        isDashboardActive() {
            return routeNames.dashboardRoutes.includes(this.$route.name);
        },
        isConfigurationActive() {
            return routeNames.configurationRoutes.includes(this.$route.name);
        },
        isAcademicUsersActive() {
            if (this.$route.name == 'employeeList' || this.$route.name == 'employeeCreate' || this.$route.name == 'employeeEdit' || this.$route.name == 'employeeDetail') {
                return false;
            }
            return routeNames.academicUsersRoutes.includes(this.$route.name);
        },
        isOperationsActive() {
            if (this.$route.name == 'employeeList' || this.$route.name == 'employeeCreate' || this.$route.name == 'employeeEdit' || this.$route.name == 'employeeDetail') {
                return true;
            }
            return routeNames.operationsRoutes.includes(this.$route.name);
        },
        isFinancesActive() {
            return routeNames.financesRoutes.includes(this.$route.name);
        },
        isCampusServicesActive() {
            return routeNames.campusServicesRoutes.includes(this.$route.name);
        },
        isReportMenuActive() {
            return routeNames.reportRoutes.includes(this.$route.name);
        },
        // config pages
        showConfiguration() {
            return this.canShowAcademicSetup || this.canShowOperationalSetup || this.canShowFinancialSetup;
        },
        canShowAcademicSetup() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },
        canShowOperationalSetup() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },
        canShowFinancialSetup() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },

        // academic and user pages
        showAcademicAndUser() {
            return this.canShowGradesAndClasses || this.canShowStudents;
        },
        canShowGradesAndClasses() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },
        canShowStudents() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },

        // operation pages
        showOperation() {
            return this.canShowStudentTracking || this.canShowEmployeeTracking || this.canShowAcademicActions || this.canShowCommunication;
        },
        canShowStudentTracking() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.CLASS_MONITOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },
        canShowEmployeeTracking() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },
        canShowAcademicActions() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.CLASS_MONITOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },
        canShowCommunication() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },

        // finance pages
        showFinance() {
            return this.canShowStudentBillings || this.canShowPayroll || this.canShowLedgerAndAssets;
        },
        canShowStudentBillings() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },
        canShowPayroll() {
            return [CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },
        canShowLedgerAndAssets() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },

        // campus service pages
        showCampusService() {
            return this.canShowFerry || this.canShowLibrary;
        },
        canShowFerry() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.HR_OPERATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },
        canShowLibrary() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.LIBRARY_ADMIN, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },

        // report pages
        showReport() {
            return [CONFIG.ROLE.ID.ADMIN, CONFIG.ROLE.ID.STAFF, CONFIG.ROLE.ID.ACCOUNTANT, CONFIG.ROLE.ID.OFFICE_ADMIN, CONFIG.ROLE.ID.PRINCIPAL, CONFIG.ROLE.ID.ACADEMIC_COORDINATOR, CONFIG.ROLE.ID.SUPER_ADMIN].includes(this.role);
        },
    },

    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
            if (!this.isMenuOpen) {
                this.openDropdownKey = null;
            }
        },
        toggleDropdown(key) {
            this.openDropdownKey = this.openDropdownKey === key ? null : key;
        },
        isDropdownOpen(key) {
            return this.openDropdownKey === key;
        },
        logoutUser() {
            axios
                .delete("/logout")
                .then((res) => {
                    if (res.data.success == true) {
                        this.$store.commit("logout");
                        this.$router.push({ name: "login" });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit("logout");
                        window.location.replace("login");
                    }
                });
        }
    }
};
</script>

<style>
@import "@/assets/css/custom/custom-header.css";
</style>
